// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CancelOrSubmit-module__withSpacing__PrgZj {\n  margin: var(--spacing-normal) 0 var(--spacing-normal) 0;\n}\n", "",{"version":3,"sources":["webpack://./src/common/buttons/CancelOrSubmit.module.css"],"names":[],"mappings":"AAAA;EACE,uDAAuD;AACzD","sourcesContent":[".withSpacing {\n  margin: var(--spacing-normal) 0 var(--spacing-normal) 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"withSpacing": "CancelOrSubmit-module__withSpacing__PrgZj"
};
export default ___CSS_LOADER_EXPORT___;
